import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "../../../../services/auth.service";
import { CommonService } from "../../../../services/common.service";
import { UserService } from "../../../../services/user.service";
import { ReservationService } from "../../../../services/reservation.service";
import { PlanService } from "../../../../services/plan.service";
import { AppConfig } from "../../../../configs/app";
import { FormatterService } from "../../../../services/formatter.service";

declare var Cleave: any;

@Component({
  selector: "page-receipt-list",
  templateUrl: "./index.component.html",
})
export class PageReceiptListComponent implements OnInit {
  public moment: any;
  public _: any;
  public $: any;

  public divisionData: any;

  public userData: any = {};
  public receiptList: any;

  public searchParams: any;
  public pagination: any = {};

  public receiptForm: any = {};
  public receiptFormUnder: any = {};
  public useUnderPrice: any;

  public receiptData: any = {};
  public pdfData: any = {};

  public tempData: any = {};

  constructor(
    public formBuilder: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public location: Location,
    public authService: AuthService,
    public commonService: CommonService,
    public userService: UserService,
    public reservationService: ReservationService,
    public planService: PlanService,
    public appConfig: AppConfig,
    public formatterService: FormatterService
  ) {
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
    this.$ = this.commonService.getJQuery();

    this.searchParams = {
      offset: 0,
      limit: this.commonService.appConfig.reservation.searchReceiptPageLimits,
    };

    /* PAGINATION */
    this.pagination = {
      offset: 0,
      limit: this.searchParams.limit,
      totalReceipts: 0,
      currentPage: 1,
      totalPages: 0,
      pageSegmentLimit:
        this.commonService.appConfig.reservation.paginationPageSegmentLimits,
      currentSegment: 1,
      totalSegments: 0,
      pageItems: [],
      hasPrev: false,
      hasNext: false,
    };

    this.receiptForm = this.formBuilder.group({
      zip: "",
      prefecture_id: "",
      prefecture_name: "",
      address: "",
      buildingName: "",
      send_name: "",
      name: "",
      proviso: "",
      remark: "",
      mode: "",
      type: "",
    });

    this.receiptFormUnder = this.formBuilder.group({
      name: ["", Validators.required],
      proviso: ["高速バス代金", Validators.required],
    });
  }

  async ngOnInit() {
    /* CHECK IF NOT LOGGED IN */
    if (!this.authService.isLoggedIn()) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageHomeNoParam
      );
    }

    /* SET PAGE TITLE */
    this.commonService.setTitle(`領収書リスト | バスブックマーク`);

    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* CHECK PAGE FROM URL */
    let page = parseInt(this.activatedRoute.snapshot.paramMap.get("page"));
    if (page > 1) {
      /* SET CURRENT PAGE & SEGMENT */
      this.pagination.currentPage = page;

      this.pagination.currentSegment =
        (this.pagination.currentPage * this.pagination.limit) /
        (this.pagination.limit * this.pagination.pageSegmentLimit);
      this.pagination.currentSegment = Number.isInteger(
        this.pagination.currentSegment
      )
        ? this.pagination.currentSegment
        : parseInt(this.pagination.currentSegment) + 1;

      this.doPagination();
    }

    /* GET DIVISION DATA */
    this.divisionData = await this.planService.getDivisions();

    /* GET USER DATA */
    this.userData = await this.userService.getProfileInfo();

    /* GET RECEIPT DATA */
    this.receiptList = await this.reservationService.getReceiptList(
      this.searchParams
    );
    this.pagination.totalReceipts = this.receiptList.totalReceipt;

    /* CALCULATE TOTAL PAGES & TOTAL SEGMENT */
    /* TOTAL PAGES */
    let totalRemainder = this.pagination.totalReceipts % this.pagination.limit;
    let total = this.pagination.totalReceipts / this.pagination.limit;
    this.pagination.totalPages =
      totalRemainder === 0 ? total : parseInt(total.toString()) + 1;

    /* CHECK INVALID PAGE */
    if (
      this.pagination.totalReceipts > 0 &&
      this.pagination.currentPage > this.pagination.totalPages
    ) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReceiptListNoParam
      );
    }
    /* END */

    /* TOTAL SEGMENTS */
    totalRemainder =
      this.pagination.totalPages % this.pagination.pageSegmentLimit;
    total = this.pagination.totalPages / this.pagination.pageSegmentLimit;
    this.pagination.totalSegments =
      totalRemainder === 0 ? total : parseInt(total.toString()) + 1;
    /* END */

    this.receiptFormUnder = this.formBuilder.group({
      name: [this.userData.name, Validators.required],
      proviso: ["高速バス代金", Validators.required],
    });

    this.doPagination();

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  doPagination() {
    /* PREV & NEXT */
    this.pagination.hasPrev = this.pagination.currentSegment > 1 ? true : false;
    this.pagination.hasNext =
      this.pagination.currentSegment < this.pagination.totalSegments
        ? true
        : false;

    /* SET PAGE RANGE */
    this.paginationSetPageRange();

    /* SET SEARCH DATA */
    this.searchParams.offset =
      (this.pagination.currentPage - 1) * this.pagination.limit;
    this.pagination.offset = this.searchParams.offset;

    /* SET URL */
    if (this.pagination.currentPage > 1) {
      this.location.replaceState(
        `${this.commonService.routePaths.pageReceiptListNoParam}/${this.pagination.currentPage}`
      );
    } else {
      this.location.replaceState(
        this.commonService.routePaths.pageReceiptListNoParam
      );
    }
  }

  paginationChangePageSegment(type: string = "prev") {
    if (type == "prev") {
      this.pagination.currentSegment--;
    } else if (type == "next") {
      this.pagination.currentSegment++;
    }

    /* SET PAGE RANGE */
    this.paginationSetPageRange();

    this.doPagination();
  }

  paginationSetPageRange() {
    this.pagination.pageItems = [];
    let pageStart =
      this.pagination.currentSegment * this.pagination.pageSegmentLimit -
      this.pagination.pageSegmentLimit +
      1;
    let pageEnd = pageStart + this.pagination.pageSegmentLimit;
    pageEnd =
      pageEnd < this.pagination.totalPages
        ? pageEnd
        : this.pagination.totalPages + 1;

    for (let i = pageStart; i < pageEnd; i++) {
      this.pagination.pageItems.push(i);
    }
  }

  async getList(page: number = 1) {
    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* SET NEW PAGINATION DATA */
    this.pagination.currentPage = page;
    this.doPagination();

    /* GET RECEIPT DATA */
    this.receiptList = await this.reservationService.getReceiptList(
      this.searchParams
    );

    /* SCROLL TO TOP */
    this.$("html, body").animate({ scrollTop: 0 }, 250);
    /* END */

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  async onSubmit() {
    for (let key in this.receiptForm.value) {
      if (this.receiptForm.value != "") {
        this.receiptData[key] = this.receiptForm.value[key];
      } else {
        this.receiptData[key] = "";
      }
    }

    if (
      this.receiptData.price >= this.appConfig.reservation.receiptPriceLimit
    ) {
      this.receiptData.type = "over";
    }

    this.receiptData.zip = this.receiptData.zip.toString().replace(/[-]/g, "");
    for (let heading of this.divisionData.division_root) {
      for (let item of this.divisionData.division[heading]) {
        if (item.id == this.receiptData.prefecture_id) {
          this.receiptData.prefecture_name = item.name;
        }
      }
    }
  }

  async conFirmReceipt() {
    this.receiptData.mode = "confirm";
    if (this.useUnderPrice == false) {
      let returnData = await this.userService.createReceipt(this.receiptData);
      if (returnData.status == "success") {
      }
    }
  }

  setPrice(price: any, reservationSlipId: any, reservationId: any) {
    if (price) {
      if (price >= this.appConfig.reservation.receiptPriceLimit) {
        this.useUnderPrice = false;
      } else {
        this.useUnderPrice = true;
      }
      this.receiptData.price = parseInt(price);
      this.receiptForm.value.price = this.receiptData.price;
    } else {
      this.receiptData.price = 0;
    }

    if (reservationSlipId) {
      this.receiptData.reservation_slip_id = reservationSlipId;
      this.pdfData.id = reservationSlipId;
    }

    if (reservationId) {
      this.receiptData.reservationId = reservationId;
      this.pdfData.reservationId = reservationId;
    }
  }

  createPDF() {
    this.tempData.formSubmitted = true;
    /* CHECK VALIDATORS */
    if (this.receiptFormUnder.invalid) {
      /* SCROLL TO THE FIRST ERROR FORM */
      if (this.$(".form-error-msg:visible").length !== 0) {
        this.$("html, body").animate(
          {
            scrollTop:
              this.$(".form-error-msg:visible").first().offset().top - 90,
          },
          200
        );
      }
      /* HIDE PAGE LOADER */
      this.commonService.hidePageLoader();
      return false;
    }

    // CHECK IF RESERVATION ID EXISTS
    // TODO: [CR-FRONT-05 #3] console.errorだけではユーザーに通知されない。
    // ローダーが消えるだけで何が起きたか分からない。UIにエラーメッセージを表示すべき。
    // また、Reservation[0]?.idがundefinedの場合（空配列等）にここに到達する。
    if (!this.pdfData.reservationId) {
      console.error('reservationId is required for PDF generation');
      this.commonService.hidePageLoader();
      return false;
    }

    //SET PDF DATA
    this.pdfData.name = this.receiptFormUnder.value.name;
    this.pdfData.proviso = this.receiptFormUnder.value.proviso;

    let userData = JSON.parse(
      localStorage.getItem(this.appConfig.auth.loginSessionName)
    );
    let token = userData.token;
    this.pdfData.token = token;
    //END

    this.reservationService.generatePDF(this.pdfData);
  }

  inlineJS() {
    let self = this;

    self.$(function () {
      new Cleave(".js-address", {
        delimiter: "-",
        blocks: [3, 4],
      });
    });
    /* END */
  }
}
